import React from "react";
import { Box, Flex, Text, Icon, HStack } from "@chakra-ui/react";
import { FaLinkedin, FaGithub } from "react-icons/fa";

function Footer({ isDark }) {
    return (
        <Box
            py={4}
            borderTop="1px solid"
            borderColor={isDark ? "gray.700" : "gray.200"}
            bg={isDark ? "gray.900" : "white"}
            position={{ base: "static", md: "fixed" }}  // Static on mobile, fixed on md+
            bottom={{ base: "auto", md: 0 }}            // Disable bottom on mobile
            left={{ base: "auto", md: 0 }}              // Disable left on mobile
            width="100%"
            zIndex={{ base: "auto", md: 999 }}          // Only needs zIndex when fixed
        >
            <Flex
                justify="space-between"
                align="center"
                px={{ base: 4, md: 10 }}
                direction={{ base: "column", md: "row" }}
                gap={{ base: 2, md: 0 }}
            >
                {/* Left side — Logo or brand text */}
                <Text
                    fontSize="sm"
                    fontWeight="medium"
                    color={isDark ? "whiteAlpha.800" : "gray.600"}
                >
                    © {new Date().getFullYear()} <b>Technically Tye</b>. All rights reserved.
                </Text>

                {/* Center — Social icons */}
                <HStack spacing={5}>
                    <Icon
                        as={FaLinkedin}
                        boxSize={5}
                        cursor="pointer"
                        color={isDark ? "white" : "black"}
                        _hover={{
                            color: isDark ? "yellow.300" : "blue.600",
                            transform: "scale(1.1)",
                            transition: "0.2s ease",
                        }}
                        onClick={() =>
                            window.open("https://www.linkedin.com/in/tyerra-sims", "_blank")
                        }
                    />

                    <Icon
                        as={FaGithub}
                        boxSize={5}
                        cursor="pointer"
                        color={isDark ? "white" : "black"}
                        _hover={{
                            color: isDark ? "yellow.300" : "blue.600",
                            transform: "scale(1.1)",
                            transition: "0.2s ease",
                        }}
                        onClick={() =>
                            window.open("https://github.com/SmithTyerra", "_blank")
                        }
                    />
                </HStack>

                {/* Right side — Optional tagline */}
                <Text
                    fontSize="sm"
                    color={isDark ? "whiteAlpha.800" : "gray.600"}
                    fontStyle="italic"
                >
                    Rarely wearing suits, but always about my business.
                </Text>
            </Flex>
        </Box>
    );
}

export default Footer;
